import { Component } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-customer-reset-password',
  templateUrl: './customer-reset-password.component.html',
  styleUrls: ['./customer-reset-password.component.scss'],
})
export class CustomerResetPasswordComponent {
  form: FormGroup;
  loading = false;
  showPassword = false;
  showConfirmPassword = false;
  token: string | null;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private api: ApiService,
    private snack: MatSnackBar,
    private router: Router
  ) {
    this.token = this.route.snapshot.queryParamMap.get('token');

    this.form = this.fb.group(
      {
        password: ['', [Validators.required, Validators.minLength(6)]],
        password_confirmation: ['', Validators.required],
      },
      { validator: this.matchPassword }
    );
  }

  matchPassword(form: FormGroup) {
    return form.get('password')?.value ===
      form.get('password_confirmation')?.value
      ? null
      : { mismatch: true };
  }

  onSubmit() {
    if (this.form.invalid || !this.token) return;

    const payload = {
      token: this.token,
      password: this.form.value.password,
      password_confirmation: this.form.value.password_confirmation,
    };

    this.loading = true;

    this.api.post('customer/reset-password', payload).subscribe({
      next: () => {
        this.loading = false;
        this.snack.open('Password updated successfully!', 'Close', {
          duration: 3000,
        });
        this.router.navigate(['/customers/login']);
      },
      error: (err) => {
        this.loading = false;
        this.snack.open(err.error?.message || 'Something went wrong', 'Close', {
          duration: 4000,
        });
      },
    });
  }
}
